<template>
  <models
    :showmodel="showeditegroup"
    :title="title"
    :canceltext="canceltext"
    :confirmtext="confirmtext"
    :needcancel="needcancel"
    @confirm="confirmedit"
    @closemodel="closeeditegroup"
    class="ifeditegroup"
  >
    <div class="maincontent">
      <el-row>
        <el-col :span="6">
          <div class="labelname"><span>性别：</span></div>
        </el-col>
        <el-col :span="18">
          <el-select
            size="small"
            v-model="selectGender"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>
  </models>
</template>
<script>
import Models from "../../../components/Models/index.vue";
export default {
  props: {
    showeditegroup: {
      type: Boolean,
    },
    gender: {
      type: String,
    },
    title: {
      type: String,
    },
    canceltext: {
      type: String,
      default: "取消",
    },
    confirmtext: {
      type: String,
      default: "确定",
    },
    needcancel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      options: [{ label:"男", value: "男" },{label:"女",value: "女"}],
      selectGender: this.gender,
    };
  },
  watch: {
    gender: function (val) {
      this.selectGender = val;
    },
  },
  components: {
    Models,
  },
  methods: {
    confirmedit() {
      let params = {
        Gender: this.selectGender
      }
      this.$store
      .dispatch("user/setuserinfo", { ...params })
      .then((res) => {
        console.log("set user info response: " + JSON.stringify(res))
        if (res.RetCode == 0) {
          this.$message.success("设置成功");
          this.$emit("closeeditegroup");
        } else {
          this.$message.error("设置失败," + res.Message);
        }
      });
    },
    closeeditegroup() {
      this.$emit("closeeditegroup");
    },
  },
};
</script>
<style lang="scss" scoped>
.ifeditegroup {
  ::v-deep .el-dialog {
    width: 450px;
    height: 250px;
  }
  ::v-deep .el-dialog__header {
    padding: 0;
  }
  ::v-deep .el-dialog__footer {
    padding: 0;
  }
  ::v-deep .el-dialog__body {
    height: 80px;
  }
  ::v-deep .el-table::before {
    background-color: #fff;
  }
  .labelname {
    min-height: 32px;
    line-height: 32px;
    text-align: center;
  }
  .maincontent {
    margin-top: 20px;
  }
  .warningtitle {
    height: 40px;
    margin-bottom: 20px;
    background-color: rgba(228, 229, 241);
    line-height: 40px;
    color: rgb(102, 102, 102);
    font-size: 14px;
    .warningcontent {
      margin-left: 20px;
    }
  }
}
</style>